
export default {
  container: {
    position: "fixed",
    top: 85,
    backgroundColor: "#fff",
    boxShadow: "rgba(0, 0, 0, 0.1) 0px 2px 14px 0px",
    height: "100%",
    maxWidth: "320px",
    minWidth: "220px",
    width: "15%"
  },
  tab: (isActive: boolean) => {
    let baseStyle: any = {
      listStyle: "none",
      alignItems: "center",
      color: "rgb(145, 151, 171)",
      fontFamily: "BrandonTextWeb-Medium",
      fontSize: 14,
      padding: "16px 40px",
      cursor: "pointer",
      "&:hover": {
          background: "rgba(222, 224, 230, 0.25)"
      }
    }

    if (isActive) {
      baseStyle.borderRight = "2px solid #ff316d";
      baseStyle.color = "#2c2c2c";
      baseStyle.background = "rgba(222, 224, 230, 0.25)";
    }

    return baseStyle;
  },
  listItemsContainer: {
    margin: 0,
    padding: 0
  }
}